import React, { Suspense } from 'react'
import { Routes, Route, Navigate, useNavigate } from 'react-router'
import { useSelector } from 'react-redux'
import styles from '@/App.module.scss'
import { Header, Footer, Loader } from 'sfy-react'

// Lazy load components for code splitting
const Home = React.lazy(() => import('@components/Home'))
const Registration = React.lazy(() => import('@components/Registration'))
const OnBoardingSteps = React.lazy(() => import('@components/OnBoardingSteps'))
const Success = React.lazy(() => import('@components/Success'))
const UpdateDetails = React.lazy(() => import('@components/UpdateDetails'))
const EmailVerification = React.lazy(() => import('@components/EmailVerification'))
const PageNotFound = React.lazy(() => import('@components/PageNotFound'))

const THEME_CONFIG = {
  ...window.appData,
}

const App = () => {
  const navigate = useNavigate()
  
  const email = THEME_CONFIG.email
  const number = THEME_CONFIG.number

  const IMAGES = {
    HEADER_LOGO: `/${window.appName}/images/logo.png`,
    SERVIFY_LOGO: `/commonAssets/servify-logo.png`,
  }

  const showLoader = useSelector((state) => state.common.showLoader)
  return (
    <React.Fragment>
      {showLoader && <Loader />}
      <Header
        className={{ header: styles['header-container'] }}
        brand={<img onClick={() => navigate('/')} src={IMAGES.HEADER_LOGO} className={styles['header-logo']} alt='brand logo' />}
      ></Header>
      <div className={styles['main-container']}>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path='/' exact element={<Home />}></Route>
            <Route path='/update-details/*' element={<UpdateDetails />}></Route>
            <Route path='/registration/*' element={<Registration />}></Route>
            <Route path='/onboarding-steps' exact element={<OnBoardingSteps />}></Route>
            <Route path='/success' exact element={<Success />}></Route>
            <Route path='/verify-email' exact element={<EmailVerification />} />
            <Route path='/page-not-found' exact element={<PageNotFound />} />
            <Route path='*' element={<Navigate to='/' replace />}></Route>
          </Routes>
        </Suspense>
      </div>
      <Footer className={{ footerContainer: `${styles['footer-container']} d-flex` }}>
        <div className={`${styles['footer-left-item']} d-flex`}>
          <p className='pr10'>Powered by</p>
          <img className={styles['logo']} src={IMAGES.SERVIFY_LOGO} alt='servify-logo' />
        </div>
        <div className='text-center'>
          For Assitance Contact&nbsp;
          <a className='text-decoration-none' href={`tel:${number}`}>
            {number}
          </a>{' '}
          |&nbsp;
          <a className='text-decoration-none' href={`mailto:${email}`}>
            {email}
          </a>
        </div>
        <div className='text-right'>&copy; Servify {new Date().getFullYear()}</div>
      </Footer>
    </React.Fragment>
  )
}

export default App
